import Dots from './ui/loader/dots';

export function FullPageSpinner() {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Dots />
    </div>
  );
}

export default FullPageSpinner;
